<template>
    <div v-if="projID && proj" class="animated fadeIn">
        <!-- 封面區域 -->
        <div class="cover-bg" v-show="!edit.cover" :style="$tools.style.imgCover($config.checkURL('pic', cover_preview))">
            <b-row class="proj-cover body-top-full justify-content-md-center" align-v="center">
                <b-col md="5" class="text-center">
                    <div class="proj-logo-area">
                        <h1 v-text="proj.name"></h1>
                        <!-- <h3 v-text="$t('menu.project_summary')"></h3> -->
                        <div class="mb-2">
                            <i class="fa fa-calendar block-text"></i>
                            <div class="block-text">{{ $t('menu.start_date') }}:</div>
                            <div class="block-text">{{ proj.start_date }}</div>
                            <div class="block-text">( {{ $tools.date.countDays(proj.start_date) + ' ' +
                                $t('u.days_ago') }} )</div>
                        </div>
                    </div>

                </b-col>

            </b-row>
        </div>
        <div class="toolbox-cover-edit" v-show="cover_files.length && edit.cover">
            <vue-cropper v-if="cover_files.length && edit.cover" ref="cropper" :src="cover_preview" :info="true"
                :aspectRatio="2.8" :fixedBox="true" :centerBox="true" :canScale="true" alt="Cover Image">
            </vue-cropper>
        </div>

        <!-- 上傳專案封面 -->
        <div class="toolbox-cover">
            <div class="proj-toolbox">
                <div class="proj-toolbox-title">
                    <i class="fa fa-wrench block-text"></i>
                    {{ $t('menu.toolbox') }}：{{ $t('menu.project') }} {{ $t('menu.cover') }}
                </div>
                <div class="proj-toolbox-body">
                    <file-upload extensions="gif,jpg,jpeg,png,webp" accept="image/png,image/gif,image/jpeg,image/webp"
                        :size="1024 * 1024 * 2" :drop="true" name="pic" class="btn btn-success btn-upload"
                        v-model="cover_files" @input-filter="image_inputFilter_cover" @input-file="check_inputFile_cover"
                        :disabled="uploading" ref="upload">
                        <i class="fa fa-plus"></i>
                        {{ $t('menu.upload_image') }}
                    </file-upload>
                    <button type="button" class="btn btn-secondary btn-upload" @click.prevent="reset_imagePreview"
                        :disabled="uploading">
                        <i class="fa fa-close"></i> {{ $t('menu.cancel') }}
                    </button>
                    <button type="submit" class="btn btn-danger btn-upload btn-red" @click.prevent="upload_image('cover', cover_files)"
                        :disabled="!Boolean(cover_files[0]) || uploading">
                        <i class="fa fa-upload"></i> {{ $t('menu.save_changes') }}
                    </button>
                </div>
            </div>
        </div>


        <!-- 專案資訊 -->
        <div class="container-fluid">

            <b-row>
                <b-col md="4">

                    <!-- 上傳專案 logo -->
                    <div class="proj-toolbox-area text-center">

                        <!-- 專案 logo -->
                        <div class="toolbox-logo" v-show="!edit.logo">
                            <img v-if="logo_preview" :src="$config.checkURL('pic', logo_preview)" :alt="proj.name + ' logo'"
                                class="proj-logo block-sm">
                            <div v-else class="proj-logo-empty block-sm">
                                <b-row align-v="center" style="height:100%;">
                                    <b-col>{{ proj.name }} logo</b-col>
                                </b-row>
                            </div>
                        </div>

                        <div class="toolbox-logo-edit" v-show="logo_files.length && edit.logo">
                            <vue-cropper v-if="logo_files.length && edit.logo" ref="cropper" :src="logo_preview" :info="true"
                                :aspectRatio="2.8" :fixedBox="true" :centerBox="true" :canScale="true" alt="Logo Image">
                            </vue-cropper>
                        </div>


                        <div class="proj-toolbox">
                            <div class="proj-toolbox-title">
                                <i class="fa fa-wrench block-text"></i>
                                {{ $t('menu.toolbox') }}：{{ $t('menu.project') }} {{ $t('menu.logo') }}
                            </div>
                            <div class="proj-toolbox-body">
                                <file-upload extensions="gif,jpg,jpeg,png,webp" accept="image/png,image/gif,image/jpeg,image/webp"
                                    :size="1024 * 1024" :drop="true" name="logo" class="btn btn-success btn-upload"
                                    v-model="logo_files" @input-filter="image_inputFilter_logo" @input-file="check_inputFile_logo"
                                    :disabled="uploading" ref="upload">
                                    <i class="fa fa-plus"></i>
                                    {{ $t('menu.upload_image') }}
                                </file-upload>
                                <button type="button" class="btn btn-secondary btn-upload" @click.prevent="reset_imagePreview"
                                    :disabled="uploading">
                                    <i class="fa fa-close"></i> {{ $t('menu.cancel') }}
                                </button>
                                <button type="submit" class="btn btn-danger btn-upload btn-red" @click.prevent="upload_image('logo', logo_files)"
                                    :disabled="! Boolean(logo_files[0]) || uploading">
                                    <i class="fa fa-upload"></i> {{ $t('menu.save_changes') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- end 專案 LOGO -->

                    <!-- 期作、感測器編輯頁面連結 -->
                    <div class="proj-toolbox-area">
                        <h4 v-text="$t('menu.subordinate_management')"></h4>

                        <template v-if="$route.name == 'Project Management'">
                            <router-link class="btn btn-success btn-upload" :to="{ name: 'Cropperiod Management' }">
                                <i class="icon-settings block-text"></i>{{ $t('menu.cropping_season_management') }}
                            </router-link>
                        </template>
                        <template v-else-if="$route.name == 'Edit Project'">
                            <router-link class="btn btn-success btn-upload" :to="{ name: 'Edit Cropperiod' }">
                                <i class="icon-settings block-text"></i>{{ $t('menu.cropping_season_management') }}
                            </router-link>
                        </template>
                    </div>
                    <!-- end 期作、感測器編輯頁面連結 -->

                    <!-- 管理專案成員 -->
                    <div v-if="user_admin || project_editable">
                        <AddMember :projectID="projID"></AddMember>
                    </div>
                    <!-- end 管理專案成員 -->


                </b-col>

                <b-col md="8">

                    <!-- 專案資訊 -->
                    <div class="proj-toolbox-area">
                        <h4 v-text="$t('menu.project_information')"></h4>
                        <p class="text-muted" v-text="$t('other.input_required')">* 為必填項目</p>
                        <b-form>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-pencil"></i>{{ $t('menu.name') }} *</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="projInfo.name"
                                              :state="$tools.input.checkRequired(projInfo.name)"
                                              :maxlength="$tools.input.getInputMaxLength('project','name')" />
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-menu"></i>{{ $t('menu.description') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-textarea type="text" v-model="projInfo.description" :rows="3" :max-rows="10"></b-form-textarea>
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="fa fa-clock-o"></i>{{ $t('menu.timezone') }} *</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-select v-if="user_admin" v-model="projInfo.timezone"
                                               :options="$moment.tz.names()"
                                               :select-size="4"></b-form-select>
                                <b-form-input v-else v-model="projInfo.timezone" :disabled="true"></b-form-input>
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-home"></i>{{ $t('menu.address') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="projInfo.address"
                                              :maxlength="$tools.input.getInputMaxLength('project','address')" />
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-location-pin"></i>{{ $t('menu.location') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="projInfo.location"
                                              :placeholder="$t('other.location_description')"
                                              :maxlength="$tools.input.getInputMaxLength('project','location')" />
                            </b-input-group>

                            <!--
                            <p class="text-muted" v-text="$t('menu.map_coordinate')">地圖中心座標</p>
                            <b-row>
                                <b-col :md="4">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.latitude') }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="text" class="form-control" v-model="projInfo.latitude" :state="checkLatitude"></b-form-input>
                                    </b-input-group>
                                </b-col>
                                <b-col :md="4">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.longitude')
                                                }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="text" class="form-control" v-model="projInfo.longitude" :state="checkLongtitude"></b-form-input>
                                    </b-input-group>
                                </b-col>
                                <b-col :md="4">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.map_zoom') }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="text" class="form-control" v-model="projInfo.zoom" :state="checkZoom"></b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            -->

                            <br>

                            <!-- Admin 專案資訊 -->
                            <div class="proj-toolbox-area" v-if="user_admin">
                                <h4>Admin Tools</h4>

                                <!-- 開始日期 -->
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-calendar"></i>{{ $t('menu.start_date') }} *
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <div>
                                        <date-picker v-model="projInfo.start_date" :lang="$tools.lang.date_picker(language)"
                                            :clearable="false" :placeholder="$t('menu.select_date')" format="YYYY-MM-DD"></date-picker>
                                    </div>
                                </b-input-group>

                                <!-- 專案到期日期 -->
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-calendar"></i>{{ $t('menu.expiry_date') }}
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <div>
                                        <date-picker v-model="projInfo.end_date" :lang="$tools.lang.date_picker(language)"
                                            :clearable="true" :placeholder="$t('menu.select_date')" :not-before="projInfo.start_date"
                                            format="YYYY-MM-DD"></date-picker>
                                    </div>
                                </b-input-group>

                                <!-- 面積、單位密度 -->
                                <UnitEditorArea :area="projInfo.area" defaultUnit="m2"
                                                :timezone="projInfo.timezone"
                                                @update-area="projInfo.area_default_unit = $event"
                                                pageType="project"></UnitEditorArea>

                                <!-- 專案上限數 -->
                                <div>
                                    <div class="block-sm">
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend>
                                                <b-input-group-text><i class="fa fa-tachometer"></i>{{ $t('n.cropping_season') }} {{ $t('menu.limit') }} *</b-input-group-text>
                                            </b-input-group-prepend>
                                            <b-form-input type="number" step="1" max="99" class="form-control"
                                                            v-model.trim="projInfo.cropperiod_max_limit" />
                                        </b-input-group>
                                    </div>
                                </div>

                                <!-- 專案服務等級 -->
                                <div>
                                    <div class="block-sm">{{ $t('menu.service_level') }} *</div>
                                    <div class="block-sm">
                                        <b-form-radio-group v-model="projInfo.service_level" :plain="true" buttons>
                                            <b-form-radio v-for="(service_level, idx_service_level) in list_project_service_level" :key="idx_service_level"
                                                :value="service_level.value" :button-variant="service_level.buttonVariant">
                                                {{ $t('status.service_level.' + service_level.value) }}</b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                </div>

                                <!-- 專案狀態 -->
                                <div>
                                    <div class="block-sm">{{ $t('menu.project') }} {{ $t('menu.status') }} *</div>
                                    <div class="block-sm">
                                        <b-form-radio-group v-model="projInfo.status" :plain="true" buttons>
                                            <b-form-radio v-for="(status, idx_status) in list_project_status" :key="idx_status"
                                                :value="status.value" :button-variant="status.buttonVariant">
                                                {{ $t('status.project.' + status.value) }}</b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                </div>

                                <!-- 專案備註 -->
                                <div>
                                    <br>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="icon-menu"></i>{{ $t('menu.admin_note') }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-textarea type="text" v-model="projInfo.note" :rows="1" :max-rows="6"></b-form-textarea>
                                    </b-input-group>
                                </div>




                            </div>
                            <!-- end Admin 專案資訊 -->


                            <div class="text-center">
                                <b-button variant="success" class="px-4 btn-upload" v-text="$t('menu.save_changes')"
                                          @click="upload_projectInfo" :disabled="uploading || checkDisabled">儲存變更</b-button>
                            </div>


                        </b-form>
                    </div>
                    <!-- end 專案資訊 -->

                </b-col>
            </b-row><!-- end b-row -->


        </div>

    </div>
</template>

<script>
    import VueCropper from 'vue-cropperjs';
    import FileUpload from 'vue-upload-component'
    import { mapState } from 'vuex'
    import UnitEditorArea from '@/views/components/UnitEditor_Area'
    import AddMember  from '@/views/admin/project/Add_Member'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'projectManagement',
        components: {
            FileUpload,
            UnitEditorArea,
            DatePicker,
            AddMember,
        },
        data: function () {
            return {
                cover_preview: undefined,
                cover_files: [],

                logo_preview: undefined,
                logo_files: [],

                edit: {
                    cover: false,
                    logo: false,
                },
                uploading: false,

                projInfo: {
                    name: '',
                    description: undefined,
                    timezone: undefined,
                    address: undefined,
                    location: undefined,
                    longitude: undefined,
                    latitude: undefined,
                    zoom: 18.6,

                    // New / Edit by Admin
                    cropperiod_max_limit: 3,
                    start_date: undefined,
                    end_date: undefined,
                    service_level: 'basic',
                    status: 'activate',
                    note: undefined,
                    payment: undefined,

                    area: undefined,
                    area_default_unit: undefined,
                },
            }
        },
        // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
        beforeRouteUpdate(to, from, next) {
            // console.log(to.params.projectID + ' ?' + Math.random());
            this.getProject(to, from, next);
        },
        mounted() {
            this.getProject();
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'language': state => state.user.language,
                'projects': state => state.project.projects,
                'project_detail': state => state.project.project_detail,
                'project_editable': state => state.project.project_editable,
                'cropperiod_default_limit': state => state.project.cropperiod_default_limit,
                'list_project_status': state => state.project.list_project_status,
                'list_project_service_level': state => state.project.list_project_service_level,
            }),

            proj() {
                return this.project_detail
            },

            projID() {
                return this.$route.params.projectID;
            },

            checkLongtitude ()
            {
                return this.$tools.input.checkFloat( this.projInfo.longitude );
            },
            checkLatitude ()
            {
                return this.$tools.input.checkFloat( this.projInfo.latitude );
            },
            checkZoom ()
            {
                return this.$tools.input.checkFloat( this.projInfo.zoom );
            },

            checkDisabled() {
                if ( this.checkLongtitude == false ) return true
                if ( this.checkLatitude == false )   return true
                if ( this.checkZoom == false )       return true

                if (this.$tools.input.checkRequired(this.projInfo.name) == false) return true;

                if (this.projInfo.cropperiod_max_limit == undefined || this.projInfo.cropperiod_max_limit == '') return true;
                if (this.projInfo.start_date == undefined || this.projInfo.start_date == '') return true;
                return false;
            },
        },
        watch: {
            cover_files() {
                if (this.cover_files.length > 0) {
                    this.cover_preview = this.cover_files[0].url;
                }
            },

            logo_files() {
                if (this.logo_files.length > 0) {
                    this.logo_preview = this.logo_files[0].url;
                }
            },

            'projInfo.cropperiod_max_limit': function (newVal, oldVal)
            {
                if ( newVal == undefined || newVal == '' || newVal > 99 ) this.projInfo.cropperiod_max_limit = this.cropperiod_default_limit
            },

        },
        methods: {

            // 取得專案資料
            getProject (to = undefined, from = undefined, next = undefined)
            {
                // console.log('projID');
                // console.log(this.projID + ' ?' + Math.random());
                let _projID = (next ? to.params.projectID : this.projID)
                // console.log(_projID);

                if (_projID != undefined)
                {
                    this.$store.dispatch('project/getProjectDetail', _projID)
                        .then(res => {
                            if (this.project_detail.editable || this.user_admin) {
                                this.reset_imagePreview();
                                this.setProjectInfo();

                                if (next) next();
                            }
                            else {
                                this.$router.push({
                                    name: 'Page403'
                                }) // 導向 403
                            }


                        })
                        .catch(err => {})
                }
            },
            // 更新介面上的專案資料
            setProjectInfo ()
            {
                this.projInfo.name          = this.project_detail.name
                this.projInfo.description   = this.project_detail.description

                // 沒有時區就猜時區
                if (this.project_detail.timezone) {
                    this.projInfo.timezone  = this.project_detail.timezone
                }
                else {
                    this.projInfo.timezone  = this.$moment.tz.guess()
                }

                this.projInfo.address       = this.project_detail.address
                this.projInfo.location      = this.project_detail.location
                this.projInfo.longitude    = this.project_detail.longitude
                this.projInfo.latitude      = this.project_detail.latitude
                this.projInfo.zoom          = this.project_detail.zoom

                // Default Value
                if (this.projInfo.zoom == undefined) this.projInfo.zoom = 18.6;

                // New / Edit by Admin
                if (this.project_detail.cropperiod_max_limit) { this.projInfo.cropperiod_max_limit = this.project_detail.cropperiod_max_limit; }
                else                                          { this.projInfo.cropperiod_max_limit = this.cropperiod_default_limit; }

                this.projInfo.service_level     = this.project_detail.service_level
                this.projInfo.start_date        = this.project_detail.start_date
                this.projInfo.end_date          = this.project_detail.end_date
                this.projInfo.status            = this.project_detail.status
                this.projInfo.note              = this.project_detail.note
                this.projInfo.payment           = this.project_detail.payment

                this.projInfo.area              = this.project_detail.area
                this.projInfo.area_default_unit = this.project_detail.area
            },


            // 上傳並更新專案基礎資訊
            upload_projectInfo ()
            {
                this.uploading = true;

                let _data = {
                    name:           this.projInfo.name,
                    timezone:       this.projInfo.timezone,

                    // nullable
                    description:    this.projInfo.description,
                    address:        this.projInfo.address,
                    location:       this.projInfo.location,
                    // latitude:       this.projInfo.latitude,
                    // longitude:     this.projInfo.longitude,
                    zoom:           this.projInfo.zoom,
                }

                // nullable
                if ( this.projInfo.latitude )  { _data.latitude = this.projInfo.latitude.toFixed(6);     } else { _data.latitude = null }
                if ( this.projInfo.longitude ){ _data.longitude = this.projInfo.longitude.toFixed(6); } else { _data.longitude = null }

                // admin 項目
                if (this.user_admin)
                {
                    _data.service_level = this.projInfo.service_level;  // 修改服務等級
                    _data.status = this.projInfo.status;                // 修改專案狀態
                    _data.note   = this.projInfo.note;                  // 修改備註

                    if (this.projInfo.cropperiod_max_limit) { _data.cropperiod_max_limit = this.projInfo.cropperiod_max_limit }

                    if (this.projInfo.start_date) { _data.start_date = this.$tools.date.dataTimeZone_to_UTC( this.projInfo.start_date, this.projInfo.timezone ); } // 轉成 UTC time

                    // nullable
                    if (this.projInfo.end_date) { _data.end_date = this.$tools.date.dataTimeZone_to_UTC( this.projInfo.end_date, this.projInfo.timezone ); }   // 轉成 UTC time
                    else                        { _data.end_date =  null }

                    _data.area = this.projInfo.area_default_unit;  // 上傳換算後的數值 - 面積
                    this.projInfo.area = undefined                 // 清除輸入介面 - 面積
                }

                const options = {
                    method: 'PUT',
                    url: this.$config.getAPI_URL('Update_Project', {
                        projectID: this.project_detail.id
                    }),
                    data: _data
                }
                this.$http(options)
                    .then(res => {
                        this.getProject();
                        this.$tools.ui.updateSideBar(this);
                        this.$toastr.s(this.$t('other.update_succeeded'), this.$t('menu.project_information'));
                    })
                    .catch(err => {
                        // console.log('更新使用者資料：err');
                        this.uploading = false;
                        this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                        this.$t('menu.project_information'));
                    })


                // 送出使用者操作紀錄 --------------------
                let _OPLog = {
                    user_id: this.$store.state.user.id,
                    type: 'write',
                    detail: {
                        page: 'project',
                        action: 'update info',
                        querySettings: {
                            'project ID':  this.project_detail.id,
                            'project name': this.projInfo.name,
                            'project status': this.projInfo.status,
                            'service level':  this.projInfo.service_level,
                            'user role':   this.project_detail.user_role,
                        },
                    },
                }
                this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                // 送出使用者操作紀錄 --------------------
            },

            // 上傳更新圖片
            upload_image (type, files)
            {
                this.uploading = true;

                let _info = {
                    uploadType: type,
                    projID:     this.project_detail.id,
                    file:       files[0].file // files[0] 為物件，要上傳 File 檔 server 才收
                }

                // 處理圖片大小
                let _oldFile = files[0].file;
                let _fileOptions = {
                    maxSize: 2000000, // 2MB
                    maxWidth: 1024,
                    minWidth: 600,
                };

                // if (type == 'logo') {
                //     _fileOptions = {
                //         maxSize: 2000000, // 2MB
                //         maxWidth: 1024,
                //         minWidth: 200,
                //     };
                // }

                let _binStr = atob(this.$refs.cropper.getCroppedCanvas(_fileOptions).toDataURL(_oldFile.type).split(
                    ',')[1]);
                let _arr = new Uint8Array(_binStr.length);
                for (let i = 0; i < _binStr.length; i++) {
                    _arr[i] = _binStr.charCodeAt(i);
                }
                _info.file = new File([_arr], _oldFile.name, {
                    type: _oldFile.type
                });


                this.$store.dispatch('project/uploadImage', _info)
                    .then(res => {
                        //  console.log('上傳成功：');
                        // console.log(res);
                        this.reset_imagePreview();
                        this.$toastr.s(this.$t('other.update_succeeded'), this.$t('menu.project') + ' ' + this.$t(
                            'menu.' + type));
                    })
                    .catch(err => {
                        // console.log('上傳失敗：err');
                        // console.log(err);
                        this.reset_imagePreview();
                        this.$toastr.e(this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                        this.$t('menu.project') + ' ' + this.$t('menu.' + type));
                    })

                // 送出使用者操作紀錄 --------------------
                let _OPLog = {
                    user_id: this.$store.state.user.id,
                    type: 'write',
                    detail: {
                        page: 'project',
                        action: 'update pic',
                        querySettings: {
                            'project ID':       this.project_detail.id,
                            'project name':     this.project_detail.name,
                            'project status':   this.projInfo.status,
                            'service level':    this.projInfo.service_level,
                            'user role':        this.project_detail.user_role,
                        },
                    },
                }
                this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                // 送出使用者操作紀錄 --------------------
            },

            reset_imagePreview ()
            {
                this.cover_files = []
                this.logo_files = []
                this.cover_preview = this.project_detail.pic
                this.logo_preview = this.project_detail.logo
                this.uploading = false;
            },

            check_inputFile_cover (newFile, oldFile, prevent)
            {
                this.$tools.input.check_inputFile(newFile, oldFile, prevent, this, 'cover')
            },
            check_inputFile_logo (newFile, oldFile, prevent)
            {
                this.$tools.input.check_inputFile(newFile, oldFile, prevent, this, 'logo')
            },
            image_inputFilter_cover (newFile, oldFile, prevent)
            {
                this.$tools.input.image_inputFilter(newFile, oldFile, prevent, this, false)
            },
            image_inputFilter_logo (newFile, oldFile, prevent)
            {
                this.$tools.input.image_inputFilter(newFile, oldFile, prevent, this, false)
            },
        },
    }

</script>

<style lang="scss" scoped>

    .toolbox-cover {
        margin-top: -38px;
        text-align: center;
    }

    .toolbox-logo {
        display: inline-block;
    }

    .toolbox-cover-edit {
        padding: 0px 20%;
        width: 100%;
        background-color: grey;
    }

    .toolbox-logo-edit {
        width: 100%;
    }

</style>
